export default "__VITE_ASSET__Qthp0Iw6__$_?inline__"